/* eslint-disable */
// 系统相关
import KgMobileCall from '../libs/jkugou_min'; // 酷狗音乐模块
window.KgMobileCall = KgMobileCall;
const OS = (() => {
    var ua = window.navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, 
    isAndroid = /(?:Android)/.test(ua),
    isAndroid4 = /(?:Android 4)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isIphone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isIphone && !isAndroid && !isSymbian,
    isQQMusic = !!(ua.match(/\bQQMUSIC\/(\d[\.\d]*)/i) || ua.match(/QQMUSIC\/(\d[\.\d]*)/i)),
    isKuwoMusic = /(?:kuwopage)/i.test(ua),
    isKuGouMusic = KgMobileCall.isInClient(),
    isWeixin = /micromessenger/i.test(ua),
    isQQ = /QQ\//i.test(ua),
    isWeibo = /weibo/i.test(ua),
    isUCbrower = /ucbrowser/i.test(ua) || /ucweb/i.test(ua),
    isQQbrower = /qqbrowser/i.test(ua);
    const OS = {
        isTablet,
        isIphone,
        isAndroid,
        isAndroid4,
        isPc,
        isQQMusic,
        isKuwoMusic,
        isKuGouMusic,
        isWeixin,
        isQQ,
        isWeibo,
        isUCbrower,
        isClient: isQQMusic || isKuwoMusic || isKuGouMusic,
        isQQbrower
    };
    return OS
})();

// 网络类型检测
export const network = (() => {
    let network_state = '未知'
    let ua = window.navigator.userAgent
    let con = window.navigator.connection
    // 如果是微信
    if (/MicroMessenger/.test(ua)) {
      // 如果是微信6.0以上版本，用UA来判断
      if (/NetType/.test(ua)) {
        let type = ua.match(/NetType\/(\S*)/)
        network_state = type[1]
        // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
      } else {
        document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
          WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
            network_state = e.err_msg
          });
        });
      }
      // 如果支持navigator.connection
    } else if (con) {
      for (let key in window.navigator) {
    //    console.log(key + '1')
      }
      let network = con.type
      network_state = network
    }
    return network_state
})()

export const plantForm = (() => {
    if (OS.isQQMusic) {
        return 'qqyin'
    }
    if (OS.isKuwoMusic) {
        return 'kuwo'
    }
    if (OS.isKuGouMusic) {
        return 'kugou'
    }
    return 'website'
})()

export const format = (date, pattern = 'yyyy-mm-dd') => {

    date = typeof date == 'object' ? date : new Date(date);

    if (!date || date == 'Invalid Date') {
        return pattern.replace(/[ymdhswq]/ig, "0");
    }

    let obj = {
        "m+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour
        "M+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "w+": "日一二三四五六".charAt(date.getDay()), //week
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        "S": date.getMilliseconds() //millisecond
    }

    if (/(y+)/.test(pattern)) {
        pattern = pattern.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
    }

    for (let key in obj) {
        if (new RegExp("(" + key + ")").test(pattern)) {
            pattern = pattern.replace(RegExp.$1, RegExp.$1.length == 1 ? obj[key] : ('00' + obj[key]).substr(("" + obj[key]).length))
        }
    }
    return pattern
}

export const serializeUrlParams = (params = {}) => {
    let strs = [];
    for (let i in params) {
        strs.push(`${i}=${params[i]}`)
    }
    return strs.join('&')
}

// 添加指定script
export const addScript = (url, cb) => {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    head.appendChild(script);
    script.onload = () => {
        typeof cb === 'function' && cb()
    }
}

export default OS